import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { initAppSettings } from './+state/app-settings.actions';
import { DeviceSearchFilterCleanupService } from './common/services/device-search-filter-cleanup/device-search-filter-cleanup.service';
import { clearGridSessions, clearPersistedGridSort } from './common/utils/session-storage.utils';

@Component({
  selector: 'cdwae-root',
  imports: [RouterOutlet],
  template: '<router-outlet></router-outlet>',
  styles: [],
})
export class AppComponent implements OnInit {
  constructor(
    private store: Store,
    _deviceSearchFilterCleanup: DeviceSearchFilterCleanupService,
  ) {}

  ngOnInit(): void {
    // Clear grid sessions and grid sort on page refresh. Column layout
    // (order/visibility/width) deliberately survives the refresh — EDUS-2902.
    clearGridSessions();
    clearPersistedGridSort();
    this.store.dispatch(initAppSettings());
  }
}
